@if (show) {
<div class="common-loader">
  <kendo-loader [type]="type" [size]="size" [themeColor]="themeColor"> </kendo-loader>
</div>
}
